<template>
  <div ref="mainRef">
    <div>
      <label
        data-required
        class="block text-900 text-sm font-medium"
      >
        {{ _t('auth.email') }}
      </label>

      <InputText
        v-model="email"
        tabindex="1"
        class="mt-2 w-full"
        :pt="{ root: { 'data-focus': 'true' } }"
      />
    </div>

    <div class="mt-5">
      <div class="flex items-center">
        <label
          data-required
          class="block text-900 text-sm font-medium"
        >
          {{ _t('auth.pwd') }}
        </label>

        <TextButton
          :label="_t('auth.forgot_pwd')"
          class="ml-auto text-14px"
          tabindex="0"
          @click="emit('resetPwd')"
        />
      </div>

      <Password
        v-model="password"
        :feedback="false"
        class="mt-2 w-full"
        inputClass="w-full"
        :inputProps="{
          tabindex: '1',
        }"
        @keydown.enter="onSignIn"
      />
    </div>

    <Button
      class="mt-8 w-full"
      :label="_t('auth.login')"
      :disabled="!isValid"
      :loading="loading"
      @click="onSignIn"
    />
  </div>
</template>

<script lang="ts" setup>
import { ref, computed, onMounted } from 'vue'
import { isEmail } from '@/utils/misc'
import { login, type UserInfo } from '@/api/auth'

const props = withDefaults(
  defineProps<{
    agreementChecked?: boolean
  }>(),
  {
    agreementChecked: true,
  }
)

const emit = defineEmits<{
  resetPwd: []
  done: [token: string, user: UserInfo]
  handleLoginWithoutAgreementChecked: []
}>()

const email = ref('')
const password = ref('')

const isValid = computed(() => {
  return isEmail(email.value) && password.value !== ''
})

const loading = ref(false)

function onSignIn() {
  if (!isValid.value) return
  if (!props.agreementChecked) {
    emit('handleLoginWithoutAgreementChecked')
    return
  }

  loading.value = true

  login({
    email: email.value,
    password: password.value,
  })
    .then(res => {
      if (res.code === 0) {
        emit('done', res.data.token, res.data.user)
      } else {
        _message.info(res.message)
      }
    })
    .finally(() => {
      loading.value = false
    })
}

// auto focus
const mainRef = ref()
onMounted(() => {
  setTimeout(() => {
    mainRef.value.querySelector('input[data-focus]').focus()
  }, 0)
})
</script>

<style scoped></style>
